(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-exchange"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.shipping-exchange-block').forEach(block => {
      const trigger = block.querySelector('.shipping-exchange-trigger');
      const modal   = block.querySelector('.shipping-exchange-modal');
      const close   = block.querySelector('.shipping-exchange-modal__close');
      const backdrop = block.querySelector('.shipping-exchange-modal__backdrop');

      if (!trigger || !modal) return;

      const openModal = () => {
        modal.showModal ? modal.showModal() : modal.setAttribute('open', '');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        modal.close ? modal.close() : modal.removeAttribute('open');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };

      trigger.addEventListener('click', openModal);
      close?.addEventListener('click', closeModal);
      backdrop?.addEventListener('click', closeModal);

      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wishlist-button"] && !Shopify.designMode) return;
  try {
    /* Block-scoped init — picks up any buttons this block renders */
  (function () {
    function syncBtn(btn) {
      if (!window.Wishlist) return;
      const handle = btn.dataset.wishlistBtn;
      const active = window.Wishlist.has(handle);
      btn.classList.toggle('wishlist-active', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');

      const label = btn.querySelector('.wishlist-btn__label');
      if (label) {
        label.textContent = active
          ? btn.dataset.labelRemove || 'Remove from wishlist'
          : btn.dataset.labelAdd || 'Add to wishlist';
      }
    }

    function initWishlistBlock() {
      document.querySelectorAll('[data-wishlist-btn]').forEach(syncBtn);
    }

    document.addEventListener('wishlist:updated', initWishlistBlock);
    initWishlistBlock();
  })();
  } catch(e) { console.error(e); }
})();

})();
